import { ComponentsCustomerType } from "@omni/types/components/customer/shared/customerType.enum";
import * as yup from "yup";

import * as RHFAddressValidationRules from "@/utils/validation/schemas/address.RHF";
import * as RHFVatValidationRules from "@/utils/validation/schemas/vat.RHF";

export const OptionalVatSchema = yup.object({
    vatInfo: yup.object({
        vatNr: RHFVatValidationRules.optionalVatNr,
        companyName: RHFAddressValidationRules.optionalCompanyName,
        vatNrPrefix: RHFVatValidationRules.vatNrPrefix
    })
});

export const RequiredVatSchema = yup.object({
    vatInfo: yup.object({
        vatNr: RHFVatValidationRules.vatNr,
        companyName: RHFAddressValidationRules.companyName,
        vatNrPrefix: RHFVatValidationRules.vatNrPrefix
    })
});

export const ConditionalyRequiredVatSchema = yup.object({
    customerType: yup
        .mixed<ComponentsCustomerType>()
        .oneOf(Object.values(ComponentsCustomerType))
        .required(),
    vatInfo: yup
        .object({
            vatNr: RHFVatValidationRules.vatNr,
            companyName: RHFAddressValidationRules.companyName,
            vatNrPrefix: RHFVatValidationRules.vatNrPrefix
        })
        .optional()
        .default(undefined)
        .when("customerType", {
            is: (val: ComponentsCustomerType) =>
                val === ComponentsCustomerType.B2B,
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.strip()
        })
});

export type OptionalVatFormValues = yup.InferType<typeof OptionalVatSchema>;
export type RequiredVatFormValues = yup.InferType<typeof RequiredVatSchema>;
export type ConditionalyRequiredVatFormValues = yup.InferType<
    typeof ConditionalyRequiredVatSchema
>;

export type VatFieldValues =
    | OptionalVatFormValues
    | RequiredVatFormValues
    | ConditionalyRequiredVatFormValues;
